import { cx, useTranslations } from "@jugl-web/utils";
import { useEffect, useState } from "react";
import mime from "mime";
import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
} from "@jugl-web/rest-api";
import { ReactComponent as DocumentIcon } from "./assets/document.svg";
import { getAttachmentIcon } from "./utils";
import { ReactComponent as PlayIcon } from "./assets/play.svg";

export const AttachmentPreview: React.FC<{
  attachment: ChatMessagePayloadAttachment;
  color: "primary" | "white";
  preview?: string;
  customIcon?: boolean;
  isOutgoing?: boolean;
}> = ({ attachment, color, preview, customIcon, isOutgoing }) => {
  const { t } = useTranslations();
  const [previewStatus, setPreviewStatus] = useState<
    "loading" | "error" | "loaded"
  >("loading");

  useEffect(() => {
    setPreviewStatus("loading");
  }, [attachment.uid]);

  return (
    <div
      className={cx(
        "relative flex h-10 w-10 shrink-0 items-center justify-center"
      )}
    >
      {previewStatus !== "error" && (
        <div
          className={cx(
            "border-dark-100 relative h-full w-full overflow-hidden rounded border border-solid",
            previewStatus !== "loaded" && "hidden"
          )}
        >
          <img
            src={preview}
            alt={attachment.name}
            className="h-full w-full object-cover"
            onError={() => setPreviewStatus("error")}
            onLoad={() => setPreviewStatus("loaded")}
          />
          {attachment.type === ChatMessageAttachmentType.video && (
            <div className="absolute inset-0 flex h-full w-full items-center justify-center bg-[rgba(26,32,35,0.50)] backdrop-blur-[2.5px]">
              <PlayIcon />
            </div>
          )}
        </div>
      )}

      {previewStatus !== "loaded" &&
        (customIcon ? (
          <div
            className={cx(
              "flex h-full w-full items-center justify-center rounded",
              isOutgoing ? "bg-dark-100" : "bg-white"
            )}
          >
            {getAttachmentIcon(attachment.mimetype)}
          </div>
        ) : (
          <>
            <DocumentIcon
              className={cx(
                color === "primary" ? "text-primary" : "text-white"
              )}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span
                className={cx(
                  "font-secondary select-none text-[10px] font-medium",
                  color === "primary" ? "text-white" : "text-primary"
                )}
              >
                {mime.getExtension(attachment.mimetype) ||
                  t({ id: "common.file", defaultMessage: "file" })}
              </span>
            </div>
          </>
        ))}
    </div>
  );
};
